var _path, _mask, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveStreaming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2C17.52 2 22 6.48 22 12C22 12.3375 21.9833 12.6711 21.9505 13H19.9325C19.9759 12.6723 20 12.3385 20 12C20 11.31 19.9 10.64 19.74 10H16.36C16.44 10.66 16.5 11.32 16.5 12C16.5 12.3374 16.4852 12.67 16.4606 13H14.4544C14.4828 12.67 14.5 12.3374 14.5 12C14.5 11.32 14.43 10.65 14.34 10H9.66C9.57 10.65 9.5 11.32 9.5 12C9.5 12.3374 9.51724 12.67 9.5456 13H7.53944C7.51478 12.67 7.5 12.3374 7.5 12C7.5 11.32 7.56 10.66 7.64 10H4.26C4.1 10.64 4 11.31 4 12C4 12.3385 4.02407 12.6723 4.06749 13H2.04934C2.01671 12.6711 2 12.3375 2 12ZM15.97 8H18.92C17.96 6.35 16.43 5.07 14.59 4.44C15.19 5.55 15.65 6.75 15.97 8ZM13.91 8C13.48 6.57 12.83 5.24 12 4.04C11.17 5.24 10.52 6.57 10.09 8H13.91ZM5.08 8H8.03C8.35 6.75 8.81 5.55 9.41 4.44C7.57 5.07 6.04 6.34 5.08 8Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C0.895431 13 0 13.8954 0 15V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V15C24 13.8954 23.1046 13 22 13H2ZM22 15H2V22H22V15Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C0.895431 13 0 13.8954 0 15V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V15C24 13.8954 23.1046 13 22 13H2ZM22 15H2V22H22V15Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15V14H1V15H2ZM22 15H23V14H22V15ZM2 22H1V23H2V22ZM22 22V23H23V22H22ZM1 15C1 14.4477 1.44772 14 2 14V12C0.343146 12 -1 13.3431 -1 15H1ZM1 22V15H-1V22H1ZM2 23C1.44772 23 1 22.5523 1 22H-1C-1 23.6569 0.343145 25 2 25V23ZM22 23H2V25H22V23ZM23 22C23 22.5523 22.5523 23 22 23V25C23.6569 25 25 23.6569 25 22H23ZM23 15V22H25V15H23ZM22 14C22.5523 14 23 14.4477 23 15H25C25 13.3431 23.6569 12 22 12V14ZM2 14H22V12H2V14ZM2 16H22V14H2V16ZM3 22V15H1V22H3ZM22 21H2V23H22V21ZM21 15V22H23V15H21Z",
    fill: "white",
    mask: "url(#path-2-inside-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.399 16.1H5.051V19.719H7.263V21H3.399V16.1ZM8.29681 16.1H9.94881V21H8.29681V16.1ZM16.5576 16.1L14.4856 21H12.8616L10.7896 16.1H12.5676L13.7366 18.963L14.9336 16.1H16.5576ZM21.3735 19.754V21H17.2995V16.1H21.2825V17.346H18.9235V17.92H20.9955V19.11H18.9235V19.754H21.3735Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveStreaming);
export default __webpack_public_path__ + "static/media/live_streaming.67a5081f.svg";
export { ForwardRef as ReactComponent };